export const LIST_PROCESS_MASTER_DETAIL_PROCESS_REQUEST =
  'LIST_PROCESS_MASTER_DETAIL_PROCESS_REQUEST'
export const LIST_PROCESS_MASTER_DETAIL_PROCESS_SUCCESS =
  'LIST_PROCESS_MASTER_DETAIL_PROCESS_SUCCESS'
export const LIST_PROCESS_MASTER_DETAIL_PROCESS_FAILURE =
  'LIST_PROCESS_MASTER_DETAIL_PROCESS_FAILURE'

export const DETAIL_LIST_PROCESS_MASTER_DETAIL_PROCESS_REQUEST =
  'DETAIL_LIST_PROCESS_MASTER_DETAIL_PROCESS_REQUEST'
export const DETAIL_LIST_PROCESS_MASTER_DETAIL_PROCESS_SUCCESS =
  'DETAIL_LIST_PROCESS_MASTER_DETAIL_PROCESS_SUCCESS'
export const DETAIL_LIST_PROCESS_MASTER_DETAIL_PROCESS_FAILURE =
  'DETAIL_LIST_PROCESS_MASTER_DETAIL_PROCESS_FAILURE'

export const DETAIL_PROCESS_MASTER_DETAIL_PROCESS_REQUEST =
  'DETAIL_PROCESS_MASTER_DETAIL_PROCESS_REQUEST'
export const DETAIL_PROCESS_MASTER_DETAIL_PROCESS_SUCCESS =
  'DETAIL_PROCESS_MASTER_DETAIL_PROCESS_SUCCESS'
export const DETAIL_PROCESS_MASTER_DETAIL_PROCESS_FAILURE =
  'DETAIL_PROCESS_MASTER_DETAIL_PROCESS_FAILURE'

export const EXPORT_PROCESS_MASTER_DETAIL_PROCESS_REQUEST =
  'EXPORT_PROCESS_MASTER_DETAIL_PROCESS_REQUEST'
export const EXPORT_PROCESS_MASTER_DETAIL_PROCESS_SUCCESS =
  'EXPORT_PROCESS_MASTER_DETAIL_PROCESS_SUCCESS'
export const EXPORT_PROCESS_MASTER_DETAIL_PROCESS_FAILURE =
  'EXPORT_PROCESS_MASTER_DETAIL_PROCESS_FAILURE'
